import { fabric } from "fabric";

export default (function() {
  function TextBox(canvas, fillColor, strokeColor, strokeWidth) {
    this.canvas = canvas;
    this.className = "Textbox";
    this.isDrawing = false;
    this.fillColor = fillColor || "#000000";
    this.strokeColor = strokeColor || "#00000000";
    this.strokeWidth = strokeWidth || 0;
    this.canvas.selection = false;
    this.textbox = null;
    this.origX = null;
    this.origY = null;
    this.width = 1;
    this.bindEvents();
  }

  TextBox.prototype.bindEvents = function() {
    this.canvas.on("mouse:down", (o) => {
      this.onMouseDown(o);
    });

    this.canvas.on("mouse:move", (o) => {
      this.onMouseMove(o);
    });

    this.canvas.on("mouse:up", (o) => {
      this.onMouseUp(o);
    });

    this.canvas.on("object:moving", () => {
      this.disable();
    });
  };

  TextBox.prototype.onMouseUp = function() {
    this.textbox.enterEditing();
    this.canvas.renderAll();
    this.disable();
  };

  TextBox.prototype.onMouseMove = function(o) {
    if (!this.isEnable()) {
      return;
    }

    var pointer = this.canvas.getPointer(o.e);
    var activeObj = this.canvas.getActiveObject();
    if (this.origX > pointer.x) {
      activeObj.set({
        left: Math.abs(pointer.x)
      });
    }
    if (this.origY > pointer.y) {
      activeObj.set({
        top: Math.abs(pointer.y)
      });
    }
    activeObj.set({
      width: Math.abs(this.origX - pointer.x)
    });
    activeObj.set({
      height: Math.abs(this.origY - pointer.y)
    });
    activeObj.setCoords();
    this.canvas.renderAll();
  };

  TextBox.prototype.onMouseDown = function(o) {
    this.enable();

    var pointer = this.canvas.getPointer(o.e);
    this.origX = pointer.x;
    this.origY = pointer.y;

    this.textbox = new fabric.Textbox('', {
      stroke: this.strokeColor,
      fill: this.fillColor,
      selectable: true,
      left: this.origX,
      top: this.origY,
      originX: "left",
      originY: "top",
      strokeWidth: this.strokeWidth,
      width: pointer.x - this.origX,
      height: pointer.y - this.origY,
      angle: 0,
      fontSize: 20,
    });

    this.canvas.add(this.textbox).setActiveObject(this.textbox);
  };

  TextBox.prototype.isEnable = function() {
    return this.isDrawing;
  };

  TextBox.prototype.enable = function() {
    this.isDrawing = true;
  };

  TextBox.prototype.disable = function() {
    this.isDrawing = false;
    this.canvas.discardActiveObject().renderAll();
  };

  return TextBox;
})();